/** Largest `pageSize` the bos-api honours on `/categories/details`. */
export const CATEGORY_DETAILS_MAX_PAGE_SIZE = 200;

export const CategoriesEndpoints = {
    list: () => '/categories/list',
    /**
     * Paged server-side (default 20, max 200). The Categories table needs
     * every row's totals to roll them up the tree, so it asks for the largest
     * page rather than silently reporting zeros for row 21 onward.
     */
    details: (pageSize = CATEGORY_DETAILS_MAX_PAGE_SIZE) =>
        `/categories/details?Page=1&PageSize=${pageSize}`,
    picker: () => '/categories/picker',
    tree: () => '/categories/tree',
    create: () => '/categories',
    update: (id: string) => `/categories/${id}`,
    delete: (id: string) => `/categories/${id}`,
    attributes: (id: string) => `/categories/${id}/attributes`,
};
